import React, { useState } from 'react';
import {toast} from "react-toastify"
import { useBulkUploadUsers, useBulkUploadLocation, useBulkUploadAssignment } from '../../hooks/api/upload/upload';
import { useFetchOrganizations } from '../../hooks/api/organisation/organisation';
import { useAddProject, useFetchProjects, useUpdateProject } from '../../hooks/api/projects/projects';
import { useFetchLocations } from '../../hooks/api/location/location';

const BulkUpload = () => {
  const [userFile, setUserFile] = useState(null);
  const [userProjectId, setUserProjectId] = useState('');
  const [locationFile, setLocationFile] = useState(null);
  const [locationOrgId, setLocationOrgId] = useState('');
  const [assessmentFile, setAssessmentFile] = useState(null);
  const [assessmentOrgId, setAssessmentOrgId] = useState('');
  const [assessmentProjectId, setAssessmentProjectId] = useState('');
  const [assessmentLocationId, setAssessmentLocationId] = useState('');

const [filters, setFilters]= useState({
  pageNum:1,
  pageSize:100000,
  orgId:""
})
//hooks
const fetchProjects= useFetchProjects(filters)
const fetchOrganisation= useFetchOrganizations()
const fetchLocation= useFetchLocations()

const uploadUsers= useBulkUploadUsers()
const uploadLocation= useBulkUploadLocation()
const uploadAssignment= useBulkUploadAssignment()
  const handleUserFileChange = (e) => {
    setUserFile(e.target.files[0]);
  };

  const handleLocationFileChange = (e) => {
    setLocationFile(e.target.files[0]);
  };

  const handleAssessmentFileChange = (e) => {
    setAssessmentFile(e.target.files[0]);
  };

  const handleSubmitUser = (e) => {
    e.preventDefault();
    // Handle user upload logic here (send file and projectId)
    console.log('User Upload:', userFile, userProjectId);

    const formData= new FormData()

    formData.append("file", userFile)
    formData.append("orgId", userProjectId)
    toast.dismiss()
    toast.loading( `Uploading Users`)
    uploadUsers.mutate(formData, {
        onSuccess(){
toast.dismiss()
toast.success(  `Users Uploaded Successfully`)
        },
        onError(){
toast.dismiss()
toast.error(`Unable to create users`)
        }
    })
  };

  const handleSubmitLocation = (e) => {
    e.preventDefault();
    // Handle location upload logic here (send file and orgId)
    console.log('Location Upload:', locationFile, locationOrgId);
    const formData= new FormData()

    formData.append("file", locationFile)
    formData.append("orgId", locationOrgId)
    toast.dismiss()
    toast.loading( `Uploading Locations`)
    uploadLocation.mutate(formData, {
        onSuccess(){
toast.dismiss()
toast.success(  `Locations Uploaded Successfully`)
        },
        onError(){
toast.dismiss()
toast.error(`Unable to create Locations`)
        }
    })
  };
  
  

  const handleSubmitAssessment = (e) => {
    e.preventDefault();
    // Handle assessment upload logic here (send file, orgId, projectId, locationId)
    console.log(
      'Assessment Upload:',
      assessmentFile,
      assessmentOrgId,
      assessmentProjectId,
      assessmentLocationId
    );


    const formData= new FormData()

    formData.append("file", assessmentFile)
    formData.append("orgId", assessmentOrgId)
    formData.append("projectId", assessmentProjectId)
    formData.append("locationId", assessmentLocationId)
    toast.dismiss()
    toast.loading( `Uploading Locations`)
    uploadAssignment.mutate(formData, {
        onSuccess(){
toast.dismiss()
toast.success(  `Locations Uploaded Successfully`)
        },
        onError(){
toast.dismiss()
toast.error(`Unable to create Locations`)
        }
    })

  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold mb-4">Bulk Upload</h2>

      {/* User Upload Section */}
      <div className="mb-8 p-4 border rounded">
        <h3 className="text-lg font-medium mb-2">Upload Users</h3>
        <form onSubmit={handleSubmitUser} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select File
            </label>
            <input
              type="file"
              onChange={handleUserFileChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select Project
            </label>
            <select
              value={userProjectId}
              onChange={(e) => setUserProjectId(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="">Select Organisation</option>
              {fetchOrganisation.data?.orgs?.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <button
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded"
          >
            Upload Users
          </button>
        </form>
      </div>

      {/* Location Upload Section */}
      <div className="mb-8 p-4 border rounded">
        <h3 className="text-lg font-medium mb-2">Upload Locations</h3>
        <form onSubmit={handleSubmitLocation} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select File
            </label>
            <input
              type="file"
              onChange={handleLocationFileChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select Organization
            </label>
            <select
              // value={locationOrgId}
              onChange={(e) => setLocationOrgId(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="">Select Organization</option>
              {fetchOrganisation.data?.orgs?.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <button
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded"
          >
            Upload Locations
          </button>
        </form>
      </div>

      {/* Assessment Upload Section */}
      <div className="p-4 border rounded">
        <h3 className="text-lg font-medium mb-2">Upload Assessments</h3>
        <form onSubmit={handleSubmitAssessment} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select File
            </label>
            <input
              type="file"
              onChange={handleAssessmentFileChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select Organization
            </label>
            <select
              // value={assessmentOrgId}
              onChange={(e) => setAssessmentOrgId(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="">Select Organization</option>
              {fetchOrganisation.data?.orgs?.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select Project
            </label>
            <select
              // value={assessmentProjectId}
              onChange={(e) => setAssessmentProjectId(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="">Select Project</option>
              {fetchProjects.data?.projects?.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select Location
            </label>
            <select
              value={assessmentLocationId}
              onChange={(e) => setAssessmentLocationId(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus">
                
                <option value="">Select Location</option>
                {fetchLocation.data?.locations?.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
                </select>

                </div>
                <button
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded"
          >
            Upload Assignment
          </button>
                </form>
                </div>
                </div>
                )}


                export default BulkUpload